module.exports = __webpack_public_path__ + "img/2.1863b546.webp";